import { utcFormat } from 'd3-time-format';
import { timeWeek, timeMonth, timeYear, TimeInterval } from 'd3-time';
import type { PeriodType } from './types';

const formatDate1M3M = utcFormat('%e %b');
const formatDate1Y3Y = utcFormat('%b %y');
const formatDate5YMax = utcFormat('%Y');

type TickFormat = ((date: Date) => string) | ((date: number) => string);

export interface Period {
  period: number;
  label: string;
  tickFormat: (TimeInterval | null)[];
  tickLabelFormat: TickFormat[];
}

export type PeriodMap = Record<PeriodType, number>;

export const getPeriodMap = (date?: Date): PeriodMap => {
  const now: Date = date || new Date();
  const TY: number = now.getFullYear();
  const TM: number = now.getMonth();
  const TD: number = now.getDate();
  const TH: number = now.getHours();
  const TMM: number = now.getMinutes();
  return {
    M1: new Date(TY, TM - 1, TD).getTime(), // 1 month ago
    M3: new Date(TY, TM - 3, TD).getTime(), // 3 months ago
    Y1: new Date(TY - 1, TM, TD).getTime(), // 1 year ago
    Y2: new Date(TY - 2, TM, TD).getTime(), // 2 years ago
    Y3: new Date(TY - 3, TM, TD).getTime(), // 3 years ago
    Y5: new Date(TY - 5, TM, TD, TH, TMM + 5).getTime(), //	5 years - 5 minute ago
    MAX: Infinity, // A long, long time ago
    NOW: now.getTime(),
  };
};

export const getPeriodList = (periodMap: PeriodMap): Period[] => [
  {
    period: periodMap.M1,
    label: '1M',
    tickFormat: [timeWeek.every(1), timeWeek.every(2)],
    tickLabelFormat: [formatDate1M3M, formatDate1M3M],
  },
  {
    period: periodMap.M3,
    label: '3M',
    tickFormat: [timeMonth.every(1), timeMonth.every(1)],
    tickLabelFormat: [formatDate1M3M, formatDate1Y3Y],
  },
  {
    period: periodMap.Y1,
    label: '1Y',
    tickFormat: [timeMonth.every(2), timeMonth.every(3)],
    tickLabelFormat: [formatDate1Y3Y, formatDate1Y3Y],
  },
  {
    period: periodMap.Y3,
    label: '3Y',
    tickFormat: [timeMonth.every(3), timeYear.every(1)],
    tickLabelFormat: [formatDate1Y3Y, formatDate5YMax],
  },
  {
    period: periodMap.Y5,
    label: '5Y',
    tickFormat: [timeYear.every(1), timeYear.every(1)],
    tickLabelFormat: [formatDate5YMax, formatDate5YMax],
  },
  {
    period: periodMap.MAX,
    label: 'Max',
    tickFormat: [timeYear.every(2), timeYear.every(2)],
    tickLabelFormat: [formatDate5YMax, formatDate5YMax],
  },
];
